import { render, staticRenderFns } from "./subdomainsIcon.vue?vue&type=template&id=39029e74"
import script from "./subdomainsIcon.vue?vue&type=script&lang=js"
export * from "./subdomainsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports